/**
 * Strips the imgix url from the given url
 * Purpose is for NuxtImg to work correctly when using the imgix provider
 * @param {string} url - The url to strip the imgix url from
 * @returns {string} The stripped url
 */
export const stripImgixUrl = (url) => {
  if (!url) return '';

  let out = String(url).trim();

  // Don't touch data/blob URLs
  if (/^(data:|blob:)/i.test(out)) return out;

  // Strip one or more leading hosts (handles: "https://x/https://x/file.jpg")
  for (let i = 0; i < 5; i++) {
    const next = out
      .replace(/^\/?https?:\/\/[^/]+/i, '')
      .replace(/^\/?\/\/[^/]+/i, '');
    if (next === out) break;
    out = next;
  }

  // Ensure it's a path for NuxtImg imgix provider
  if (out && !out.startsWith('/')) out = `/${out}`;

  return out;
};